import styles from "components/ui/ParticipationStatusBar/ParticipationStatusBar.module.scss";
import { ReactComponent as IconComments } from "features/comments/assets/comment.svg";
import { ReactComponent as IconLike } from "features/likes/components/ButtonLike/assets/images/like.svg";
import { ReactComponent as IconReply } from "features/comments/assets/reply.svg";
import PropTypes from "prop-types";
import Button from "components/ui/Button/Button";

const ParticipationStatusBar = ({ commentCount, likeCount = 0, onReply, variant = `` }) => {
  const likeSectionClasses = [styles.section, styles.likes];
  const commentSectionClasses = [styles.section, styles.comments];

  let classes = [styles.bar];
  if (variant) {
    classes.push(styles[`bar--teaser`]);
  }

  return (
    <div className={ classes.join(` `) }>
      <div className={ likeSectionClasses.join(` `) }>
        <IconLike/>
        { `${ likeCount === 1 ? `1 lid vind` : `${ likeCount } leden vinden` } dit leuk` }
      </div>

      {
        commentCount !== undefined &&
        <div className={ commentSectionClasses.join(` `) }>
          <IconComments/>
          { `${ commentCount } reactie${ Number(commentCount) === 1 ? `` : `s` }` }
        </div>
      }

      {
        onReply &&
        <Button variant={ `ghost-borderless` }
                onClick={ onReply }
                className={ `button--small` }>
          <IconReply/>
          Reageren
        </Button>
      }
    </div>
  )
}

ParticipationStatusBar.propTypes = {
  likeCount: PropTypes.number,
  commentCount: PropTypes.number,
  onReply: PropTypes.func,
  variant: PropTypes.string,
}

export default ParticipationStatusBar;
